module.exports = __webpack_public_path__ + "img/Paginierung_Haken.881b8eac.svg";